import * as types from './types';

export const setAutostartTV = payload => ({
  type: types.SET_AUTOSTART_TV,
  payload,
});
